import { filter, join, map, pipe } from "ramda";
import { Entity, EntityDropdownOption } from "src/documentUpload/types";
import { ModelTemplate } from "src/metadata/types";

import { decodeHtml, toTitleCase } from "src/helpers";

export const transformSearchEntityResults = (entities: Entity[]) =>
  map(transformSingleEntityResult, entities);

export const composeHumanReadableLabel = ({
  name,
  city,
  country
}: Entity): string => {
  const location = join(
    ", ",
    filter(value => value.length !== 0, [city, country])
  );

  const humanReadableLabel = `${name} ${location}`;
  return humanReadableLabel;
};

export const transformSingleEntityResult = (
  entity: Entity
): EntityDropdownOption => {
  const label = formatEntityValue(entity.name);

  return {
    label,
    value: entity
  };
};

export const formatEntityValue = pipe(decodeHtml, toTitleCase);

export const transformModelTemplateIntoDropwdownOptions = (
  modelTemplates: ModelTemplate[]
) =>
  map(
    (modelTemplate: ModelTemplate) => ({
      label: modelTemplate.modelTemplateType,
      value: modelTemplate
    }),
    modelTemplates
  );



// WEBPACK FOOTER //
// ./src/documentUpload/helpers.ts